"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.tooltip.view': 'Visualizza dettagli onboarding',
    'onboarding.tooltip.edit': 'Modifica voce onboarding',
    'onboarding.tooltip.delete': 'Elimina voce onboarding',
};
